// TABS
document.addEventListener('DOMContentLoaded', function() {
  

  const tabsWraps = document.querySelectorAll('.c-tabs-wrap');
  if(tabsWraps.length > 0){
    tabsWraps.forEach(tabsWrap => {
      initTabs(tabsWrap);
    });

    function initTabs(tabsWrap){
      const tabLinks = tabsWrap.querySelectorAll('.c-tab-link'),
            tabPanels = tabsWrap.querySelectorAll('.c-tabs-panel');

      tabLinks.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          tabLinks.forEach(link => link.classList.remove('active'));
          tabPanels.forEach(panel => panel.classList.remove('active'));

          tab.classList.add('active');
          tabPanels[index].classList.add('active');
        });
      });
    }
  }
});